import {
    getAction,
    postAction,
    uploadData
} from '@/utils/axios'

// 登录
export const login = (params) => postAction('sys/login', params);

// 注册
export const regisiter = (params) => postAction('sys/register', params);

// 修改密码
export const modifyPass = (params) => postAction('sys/modifyPass', params);

// 验证token有效性
export const verifyToken = (params) => postAction('sys/verifyToken', params);

// 获取APP列表
export const getAppList = (params) => postAction('siteInfo/getAppList', params);

// 删除app
export const deleteApp = (params) => postAction('siteInfo/deleteApp', params);

// 获取页面配置
export const getSiteConfigInfo = (params) => postAction('siteInfo/getConfigInfo', params);

// 修改页面配置
export const editSiteConfig = (params) => postAction('siteInfo/editSiteConfig', params);

// 新增配置文件
export const createSiteConfig = (params) => postAction('siteInfo/createSiteConfig', params);

export const inactiveTikTokConfig = (params) => postAction('siteInfo/inactiveTikTokConfig', params);

export const generateTikTokConfig = (params) => postAction('siteInfo/generateTikTokConfig', params);
export const getTikTokConfig = (params) => postAction('siteInfo/getTikTokConfig', params);
// 获取app统计数据
export const getAppCount = (params) => getAction('siteInfo/getAppCount', params);
